module.exports = __webpack_public_path__ + "700a494545a43487bce02b17b68b3870.png";